// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"currency-component_uk-open__lCD3G","grecaptcha-badge":"currency-component_grecaptcha-badge__SJgC0","fullPrice":"currency-component_fullPrice__t609A","cent":"currency-component_cent__m1gRB","dash":"currency-component_dash__BhsTC"};
    if(module.hot) {
      // 1793877036849
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  